<template>
  <div class="flv-video-box" ref="fvRef">
    <!-- :style="videoStyle"-->
    <div class="monitor">
      <!-- 头部 -->
      <div class="r-top">
        <div class="r-top-code">code：{{ currentRobot.code }}</div>
        <div class="r-top-time">{{ time }}</div>
      </div>

      <!-- 机器人数据展示 :class="{'layout-column': robotNum>1}"-->
      <div class="r-show-data" >
        <div class="left-monitoring">
          <video id="videoLeftElement" ref="videoLeft" :muted="videoMuted">
          </video>
          <div class="audio-btn-box" @click="videoMuted = !videoMuted" v-if="false">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1em" height="1em">
              <path d="M260.256 356.576l204.288-163.968a32 32 0 0 1 52.032 24.96v610.432a32 32 0 0 1-51.968 24.992l-209.92-167.552H96a32 32 0 0 1-32-32v-264.864a32 32 0 0 1 32-32h164.256zM670.784 720.128a32 32 0 0 1-44.832-45.664 214.08 214.08 0 0 0 64.32-153.312 213.92 213.92 0 0 0-55.776-144.448 32 32 0 1 1 47.36-43.04 277.92 277.92 0 0 1 72.416 187.488 278.08 278.08 0 0 1-83.488 198.976zM822.912 858.88a32 32 0 1 1-45.888-44.608A419.008 419.008 0 0 0 896 521.152c0-108.704-41.376-210.848-114.432-288.384a32 32 0 0 1 46.592-43.872c84.16 89.28 131.84 207.04 131.84 332.256 0 127.84-49.76 247.904-137.088 337.728z" fill="currentColor"></path>
            </svg>
            <p class="hidden-line" v-show="videoMuted"></p>
          </div>
          <!--加载动画-->
          <div class="buffer-loading-box" v-show="bufferLoad">
            <p class="loading-content"><Spin fix></Spin></p>
            <div>{{ langMap.buffering[lang] }}</div>
          </div>
        </div>

      </div>

      <!-- 不在线提示 -->
      <div class="state" v-if="offline">
        <div style="margin:20% auto;width: 80%;text-align: center">
          <p style="font-size: 30px;color: #FFFFFF">{{ langMap.robotIsOffline[lang] }}</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import flvjs from "flv.js";
import maxLogo from "@/assets/images/logo.png";
import fg from "@/assets/images/lol/fg.png";
import dd from "@/assets/images/lol/dd.png";
import warning from "@/assets/images/lol/Warning.png";
import countTo from "vue-count-to";
import * as timeUtil from "@/utils/dateTimeUtil.js";
import api from "@/api";
import { sendMsg, buildWebSocketUrl, connectWithUrl } from "@/utils/websocket.js";
import ScaleBox from "@/components/scale-box/ScaleBox.vue";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
// 最小的尺寸
const H = 680;
const W = 823;
// 用来计算缩放的
const rw = 1000;
const rh = 800;

export default {
  name: "flv-video",
  components: {
    countTo,
    ScaleBox
  },
  props: {
    robotId: {
      type: Number,
      default: ""
    },
    robotNum: {
      type: Number,
      default: 2
    },
    videoPlayUrlPrefix: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      langMap:langMap,
      id: "",
      timestamp: "",
      warningImg: warning,
      offline: false,
      fg,
      dd,
      time: "",
      maxLogo,
      rotate: 0,
      videoStyle: null,
      videoMuted: true, // 声音状态, true为静音
      bufferLoad: false, // 数据缓冲状态
      version: {},
      status: {},
      movement: {},
      notice: {},
      height: document.documentElement.clientHeight,
      currentRobot: {}, // 机器人对象
      exhibition: ["R", "O", "T", "U", "N", "B", "O", "T"],
      notice: {},
      isShow1: false,
      isShow2: false,
      warn: {}, // 二级
      special: {}, // 一级
      specialNum: 0,
      warnNum: 0,
      sentimentData: null,
      gunData: null,
      leftFlvPlayer: null,
      rightFlvPlayer: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
  },
  methods: {
    formatTime(t) {
      if (!t) {
        return "";
      }
      return timeUtil.formatTime(t);
    },
    start() {
      // 将定时器名字赋值到变量中
      this.timer = setInterval(() => {
        this.time = timeUtil.formatTime(new Date().getTime());
      }, 1000);
    },
    getInfo(id) {
      api.getData("robot-server/robot/get/" + id, this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.currentRobot = res.data;
          if (!this.offline) {
            this.createFlvPlayer();
          }
        }
      });
    },
    //新建flv实例
    createFlvPlayer() {
      if (!flvjs.isSupported()) return console.error();
      let _that = this;
      var leftVideoElement = this.$refs.videoLeft;
      const url = this.videoPlayUrlPrefix + "_left_" + this.currentRobot.code;

      this.leftFlvPlayer = flvjs.createPlayer(
        {
          type: "flv",
          url: url,
          //url: 'http://localhost:8080/live/livestream.flv',// srs 测试地址
          isLive: true,
          cors: true, // 开启跨域访问
          // TIP: 显示设置true时，若不含音频流会导致加载失败；【flv.js会自动检测音频流播放，无需设置】
          //hasAudio: true,
          duration: 0,
          currentTime: 0
        },
        {
          autoCleanupSourceBuffer: true, //对SourceBuffer进行自动清理
          autoCleanupMaxBackwardDuration: 10, //    当向后缓冲区持续时间超过此值（以秒为单位）时，请对SourceBuffer进行自动清理
          autoCleanupMinBackwardDuration: 8, //指示进行自动清除时为反向缓冲区保留的持续时间（以秒为单位）。
          enableStashBuffer: false, //关闭IO隐藏缓冲区
          //enableWorker: true, // 启用分离的线程进行转换
          stashInitialSize: 100 * 1024, // 减少首帧显示等待时长
          stashInitialTime: 0.8,
          isLive: true,
          lazyLoad: true,
          maxBufferingTime: 10,
          stashTime: 10,
        }
      );
      /**监听是否存在音频流*
      _that.leftFlvPlayer.on(flvjs.Events.MEDIA_INFO, ({hasAudio,audioCode}) => {
        console.info("[media信息]", hasAudio,audioCode);
      })*/

      this.leftFlvPlayer.attachMediaElement(leftVideoElement);
      this.leftFlvPlayer.load();


      let flag = false;
      let lastDecodedFrames = 0;
      let stuckTime = 0;
      // 加载几秒后播放
      setTimeout(() => {
        _that.leftFlvPlayer.play();
      }, 3000);
      //用于视频延时，超过1分钟，就关闭当前流且重新拉流； 每5s循环监听一次
      let timer = setInterval(() => {
        if (!_that.leftFlvPlayer) return;
        console.info("[buffered]", _that.leftFlvPlayer,url);

        if (_that.leftFlvPlayer.buffered && _that.leftFlvPlayer.buffered.length) {
          _that.bufferLoad = false; // 关闭加载
          /* 判断是否卡顿*/
          const decodedFrames = _that.leftFlvPlayer.statisticsInfo.decodedFrames;
          if (lastDecodedFrames != decodedFrames) lastDecodedFrames = decodedFrames;
          console.info("[decodedFrames值]",decodedFrames);
          if (lastDecodedFrames === decodedFrames && !leftVideoElement.paused) {
            stuckTime++;

            // 卡顿次数超过8
            if (stuckTime > 8) {
              console.info("[出现卡顿-重新创建]");
              lastDecodedFrames = decodedFrames;
              _that.refPlay(timer, _that);
              return;
            }
          }

        } else {
          _that.bufferLoad = true; // 显示加载
        }
      }, 5000);

      _that.leftFlvPlayer.on(flvjs.Events.ERROR,(errorType, errorDetail, errorInfo) => {
          console.error("[flv 错误触发]", errorType, errorDetail);

          if (_that.leftFlvPlayer) {
            //视频出错后销毁重新创建
            _that.refPlay(timer, _that);
          }
        }
      );

    },

    refPlay(timer, _that) {
      //多个视频用
      clearInterval(timer);
      _that.leftFlvPlayer.pause();
      _that.leftFlvPlayer.unload();
      _that.leftFlvPlayer.detachMediaElement();
      _that.leftFlvPlayer.destroy();
      _that.leftFlvPlayer = null;

      //重新加载当前停止的视频流，根据个人的方法来配置
      this.createFlvPlayer();
    },
    initSocket() {
      connectWithUrl('/ssdd', "dataSocketUrl", this.id, this.dataCallback);
    },
    dataCallback(data) {
      this.offline = false;
      //console.log(data);
      let ret = JSON.parse(data);
      switch (ret.type) {
        case "fail":
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: ret.data
          });
          this.offline = true;
          break;
        case "online:":
          this.offline = false;
          this.createFlvPlayer();
          break;
        case "offline:":
          this.offline = true;
          break;
        case "status:":
          this.status = ret.data;
          break;
        case "movement:":
          this.movement = ret.data;
          break;
        case "version:":
          this.version = ret.data;
          break;
        case "notice:":
          this.notice = ret.data;
          if (ret.data.type === 1) {
            this.specialNum = 11;
            if (!this.isShow1) {
              this.showSpecial(ret.data);
            }
          } else if (ret.data.type === 0) {
            this.warnNum = 11;
            if (!this.isShow2) {
              this.showWarn(ret.data);
            }
          }
          break;
        case "gun:":
          this.gunData = ret.data;
          break;
        case "sentiment:":
          this.sentimentData = ret.data;
          break;
      }
    },
    // 倒数10秒
    async showSpecial(data) {
      this.special = data;
      while (this.specialNum >= 0) {
        this.isShow1 = true;
        const logStr = await this.sleepFun(this.specialNum);
        // console.log("special---" + logStr);
        this.specialNum = this.specialNum - 1;
      }
      this.isShow1 = false;
    },
    async showWarn(data) {
      this.warn = data;
      while (this.warnNum >= 0) {
        this.isShow2 = true;
        const logStr = await this.sleepFun(this.warnNum);
        // console.log("warn---" + logStr);
        this.warnNum = this.warnNum - 1;
      }
      this.isShow2 = false;
    },
    sleepFun(logStr) {
      return new Promise(res => {
        return setTimeout(() => {
          res(logStr);
        }, 1000);
      });
    },
    getHandle() {
      if (this.id && this.timestamp) {
        api
          .getData(
            "notice-server/data/get/handle?robotId=" +
              this.id +
              "&timestamp=" +
              this.timestamp,
            this
          )
          .then(res => {
            if (res.state == 0) {
              this.$Notice.error({
                title: langMap.tip[this.lang],
                desc: res.msg
              });
            } else {
              this.gunData = res.data.gunData;
              this.sentimentData = res.data.sentimentData;
            }
          });
      }
    },
    onSize() {
      const el = this.$refs.fvRef;

      const elH = el.offsetHeight;
      const elW = el.offsetWidth;

      if (elH >= H && elW >= W) {
        this.videoStyle = { height: "100%", width: "100%" };
        return;
      }

      let s = {
        height: "100%",
        width: "100%",
        left: 0,
        marginLeft: 0,
        transform: ""
      };

      if (elH < H) {
        s.height = rh + "px";
        const r = (elH / rh).toFixed(1);
        s.transform = `scale(${r})`;
      }

      if (elW < W) {
        s.width = rw + "px";
        s.left = "50%";
        s.marginLeft = `-${rw / 2}px`;
        const r = (elW / rw).toFixed(1);
        s.transform = `scale(${r})`;
      }

      this.$nextTick(() => {
        this.videoStyle = s;
      });
    },
  },
  mounted() {
    this.start();
    this.getInfo(this.robotId);
    // 网页重新激活后，更新视频
    window.onfocus = () => {
      if (!this.leftFlvPlayer) return;
      let end = this.leftFlvPlayer.buffered.end(0) - 1;
      this.leftFlvPlayer.currentTime = end;
    };
  },
  created() {
    this.id = this.currentRobot.id;
    this.timestamp = this.$route.query.timestamp;
    //this.initSocket();
  }
  /*
  beforeDestory() {
    window.removeEventListener(window,'resize', this.onSize);
  }*/
};
</script>


<style scoped  lang="less">
.flv-video-box {
  height: 100%;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  background-color: #000;
  position: relative;
}
.kz {
  text-align: center;
  padding: 5px 20px 5px 20px;
  font-size: 15px;
  color: red;
}

.monitor {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .special {
    position: absolute;
    top: 25%;
    left: 44%;
    color: red;
    font-size: 45px;
    text-align: center;
    line-height: 100px;
    font-weight: bold;
    animation: blink 1s linear infinite;
    -webkit-animation: blink 1s linear infinite;
    -moz-animation: blink 1s linear infinite;
    -ms-animation: blink 1s linear infinite;
    -o-animation: blink 1s linear infinite;
    animation: imgs 1s linear infinite;
    -webkit-animation: imgs 1s linear infinite;
    -moz-animation: imgs 1s linear infinite;
    -ms-animation: imgs 1s linear infinite;
    -o-animation: imgs 1s linear infinite;
    z-index: 99;

    .img {
      width: 45px;
      height: 45px;
      margin-right: 13px;
      margin-bottom: -5px;
    }
  }

  @keyframes imgs {
    0% {
      opacity: 1;
      /*透明度为1*/
    }

    50% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes blink {
    0% {
      color: red;
    }

    50% {
      color: transparent;
    }

    100% {
      color: red;
    }
  }
}

// 头部
.r-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 0;
  background-color: #000;
  color: #bab7b7;
  font-size: 20px;
  .r-top-code {
    padding-left: 10px;
  }
  .r-top-time {
    flex-shrink: 0;
    padding-right: 35px;
  }
}

// 机器人数据展示
.r-show-data {
  display: flex;
  flex: 1;
  flex-direction: row;
  background-color: #001529;
  height: calc(100% - 50px);
  .left-monitoring {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    overflow: auto;
    justify-content: center;
    video {
      width: 100%;
      height: 100%;
    }
  }
  .audio-btn-box {
    position: absolute;
    bottom: 20px;
    left: 10px;
    z-index: 10;
    background-color: rgba(1, 0, 1, 0.6);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    color: white;
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      background-color: rgba(1, 0, 1, 0.3);
    }
    .hidden-line {
      position: absolute;
      margin: 0;
      padding: 0;
      width: 60%;
      left: 20%;
      height: 3px;
      top: 50%;
      transform: rotate(60deg);
      z-index: 3;
      background-color: white;
      border-radius: 6px;
    }
  }

  /deep/.ivu-col-span-24 {
    flex: 1;
  }

  .right-monitoring {
    height: 100%;
    width: 50%;
    position: relative;

    .detailed {
      padding: 20px;
      overflow: hidden;
    }

    video {
      width: 100%;
      height: 100%;
    }
  }
}

.layout-column {
  flex-direction: column;
  align-items: center;
  .left-monitoring {
    height: 50%;
  }
  .right-monitoring {
    height: 50%;
  }
}

.text-key {
  color: #ffffff;
  font-size: 12px;
  flex-wrap: nowrap;
}

.text-value {
  // padding-left: 5px;
  color: #00ffff;
  font-size: 15px;

  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
}

.text-row {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

// 不在线提示
.state {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #000c17;
  width: 100%;
  height: 100%;
  z-index: 10000;
}

.handle {
  margin: 5px;
  padding: 5px 21px 6px;
}
// 加载部分
.buffer-loading-box{
  position: absolute;
  width: 400px;
  left: 50%;
  margin-left: -200px;
  padding: 0 0 16px 0;
  top: 100px;
  z-index: 10;
  //background-color: rgba(1,1,0,0.2);
  text-align: center;
  color: #2d8cf0;
  .ivu-spin-fix{background-color: transparent;}
  .loading-content{
    height: 40px;
    position: relative;
  }
}

</style>
